<template>
    <PageComponent 
        :loader="loader" @showLoader="showLoader" @hideLoader="hideLoader"
        :addButtonLabel="addButtonLabel"
        @handleAddNew="addNewChannel"
        :searchFilters="searchFilters"
        :dropdownOptions="dropdownOptions"
        @handleDynamicOption="handleDynamicOption"
        @searchPage="searchChannels"
        @resetFilters="resetFilters"
        @removeItem="removeChannel"
        @removeSelectedItems="removeChannels"
        :addingRight="addingRight"
        :removingRight="removingRight"
        :rightsModule="rightsModule"
        :columns="tableColumns"
        :rows="channelsList"
        :actions="actions"
        :idField="idField"
        @handleSelectionChange="handleSelectionChange"
        @handleActionClick="handleActionClick"
        :count="depCount"
        :currentPage="currentPage"
        :result="depArrLen"
        @loadPrev="loadPrev"
        @loadNext="loadNext"
        @firstPage="firstPage"
        @lastPage="lastPage"
        :showNextBtn="showNextBtn"
        :showPreviousBtn="showPreviousBtn"
        :selectedValue="selectedValue"
        @selectSearchQuantity="selectSearchQuantity"
    />
    <MovableModal v-model:visible="depModalVisible" :title="title" :modal_top="modal_top" :modal_left="modal_left" :modal_width="modal_width"
        :loader="modal_loader" @showLoader="showModalLoader" @hideLoader="hideModalLoader"  @closeModal="closeModal">
        <DynamicForm 
            :fields="formFields" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" 
            :displayButtons="displayButtons" @handleSubmit="saveChannel" @handleReset="handleReset"
        />
    </MovableModal>
</template>

<script>
import axios from "axios";
import { ref, computed, watch, onMounted, onBeforeMount } from 'vue';
import PageComponent from '@/components/PageComponent.vue'
import MovableModal from '@/components/MovableModal.vue'
import DynamicForm from '../NewDynamicForm.vue';
import { useStore } from "vuex";
import { useToast } from "vue-toastification";

export default{
    name: 'Marketing_Channels',
    components:{
        PageComponent,MovableModal,DynamicForm
    },
    setup(){
        const store = useStore();
        const toast = useToast();
        const loader = ref('');
        const modal_loader = ref('none');
        const title = ref('Channel Details');
        const addButtonLabel = ref('New Channel');
        const addingRight = ref('Adding Marketing Channels');
        const removingRight = ref('Deleting Marketing Channels');
        const rightsModule = ref('CRM');
        const idField = 'marketing_channel_id';
        const selectedIds = ref([]);
        const depModalVisible = ref(false);
        const channelsList = ref([]);
        const depResults = ref([]);
        const depArrLen = ref(0);
        const depCount = ref(0);
        const pageCount = ref(0);
        const currentPage = ref(1);
        const showNextBtn = ref(false);
        const showPreviousBtn = ref(false);
        const selectedValue = ref(50);
        const flex_basis = ref('');
        const flex_basis_percentage = ref('');
        const displayButtons = ref(true);
        const errors = ref([]);
        const modal_top = ref('200px');
        const modal_left = ref('400px');
        const modal_width = ref('30vw');
        const isEditing = computed(()=> store.state.Marketing_Channels.isEditing)
        const selectedChannel = computed(()=> store.state.Marketing_Channels.selectedChannel);
        const tableColumns = ref([
            {type: "checkbox"},
            {label: "Name", key: "name", type: "text", editable: false},
            {label: "Type", key: "channel_type", type: "text", editable: false},
            {label: "Description", key: "description", type: "text", editable: false},
        ])
        const actions = ref([
            {name: 'edit', icon: 'fa fa-edit', title: 'Edit Channel', rightName: 'Editing Marketing Channels'},
            {name: 'delete', icon: 'fa fa-trash', title: 'Delete Channel', rightName: 'Deleting Marketing Channels'},
        ])
        const companyID = computed(()=> store.state.userData.company_id);
        const name_search = ref('');
        const type_search = ref('');
        const searchFilters = ref([
            {type:'text', placeholder:"Search Name...", value: name_search},
            {
                type:'dropdown', placeholder:"Type..", value: type_search, width:36,
                options: [{text:'Digital',value:'Digital'},{text:'Offline',value:'Offline'}]
            },
        ]);
        const handleSelectionChange = (ids) => {
            selectedIds.value = ids;
        };
        const formFields = ref([]);
        const updateFormFields = (channel) => {
            formFields.value = [
                { type: 'text', name: 'name',label: "Name", value: channel?.name || '', required: true },
                { type: 'dropdown', name: 'channel_type',label: "Type", value: channel?.channel_type || '', required: true, options: [{text:'Digital',value:'Digital'},{text:'Offline',value:'Offline'}] },
                { type: 'text-area', name: 'description',label: "Description", value: channel?.description || '', textarea_rows: '3', textarea_cols: '56', required: false },
            ];
        };
        watch(selectedChannel, (newChannel) => {
            updateFormFields(newChannel);
        }, { immediate: true });
        const addNewChannel = () =>{
            depModalVisible.value = true;
            handleReset();
            store.dispatch("Marketing_Channels/updateState",{isEditing:false})
            flex_basis.value = '1/2';
            flex_basis_percentage.value = '50';
        }
        const handleActionClick = async(rowIndex, action, row) =>{
            if( action == 'edit'){
                const channelID = row[idField];
                let formData = {
                    company: companyID.value,
                    marketing_channel: channelID
                }
                await store.dispatch('Marketing_Channels/fetchMarketingChannel',formData).
                then(()=>{
                    depModalVisible.value = true;
                    flex_basis.value = '1/2';
                    flex_basis_percentage.value = '50';
                })
                
            }else if(action == 'delete'){
                const channelID = [row[idField]];
                let formData = {
                    company: companyID.value,
                    marketing_channel: channelID
                }
                await store.dispatch('Marketing_Channels/deleteMarketingChannel',formData).
                then(()=>{
                    searchChannels();
                })
            }
        } 
        const handleReset = () =>{
            for(let i=0; i < formFields.value.length; i++){
                formFields.value[i].value = '';
            }
        }
        const showModalLoader = () =>{
            modal_loader.value = "block";
        }
        const hideModalLoader = () =>{
            modal_loader.value = "none";
        }
        const createMarketingChannel = async() =>{
            showModalLoader();
            let formData = {
                name: formFields.value[0].value,
                channel_type: formFields.value[1].value,
                description: formFields.value[2].value,
                company: companyID.value
            }
            errors.value = [];
            for(let i=0; i < formFields.value.length; i++){
                if(formFields.value[i].value =='' && formFields.value[i].required == true){
                    errors.value.push('Error');
                }
            }
            if(errors.value.length){
                toast.error('Fill In Required Fields');
                hideModalLoader();
            }else{
                try {
                    const response = await store.dispatch('Marketing_Channels/createMarketingChannel', formData);
                    if(response && response.status === 201) {
                        hideModalLoader();
                        toast.success('Marketing Channel created successfully!');
                        handleReset();
                    }else {
                        toast.error('An error occurred while creating the Marketing Channel.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to create Marketing Channel: ' + error.message);
                } finally {
                    hideModalLoader();
                    searchChannels();
                }
            }

        }
        const updateMarketingChannel = async() =>{
            showModalLoader();
            errors.value = [];
            let formData = {
                name: formFields.value[0].value,
                channel_type: formFields.value[1].value,
                description: formFields.value[2].value,
                company: companyID.value,
                marketing_channel: selectedChannel.value.marketing_channel_id
            }
            for(let i=0; i < formFields.value.length; i++){
                if(formFields.value[i].value =='' && formFields.value[i].required == true){
                    errors.value.push('Error');
                }
            }
            if(errors.value.length){
                    toast.error('Fill In Required Fields');
            }else{
                try {
                    const response = await store.dispatch('Marketing_Channels/updateMarketingChannel', formData);
                    if (response && response.status === 200) {
                        hideModalLoader();
                        toast.success("Marketing Channel updated successfully!");
                        handleReset();
                    } else {
                        toast.error('An error occurred while updating the Marketing Channel.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to update Marketing Channel: ' + error.message);
                } finally {
                    hideModalLoader();
                    searchChannels();
                }
            }
        }
        const saveChannel = () =>{
            if(isEditing.value == true){
                updateMarketingChannel();
            }else{
                createMarketingChannel();
            }
        }
        const removeChannel = async() =>{
            if(selectedIds.value.length == 1){
                let formData = {
                    company: companyID.value,
                    marketing_channel: selectedIds.value,
                }
                try{
                    const response = await store.dispatch('Marketing_Channels/deleteMarketingChannel',formData)
                    if(response && response.status == 200){
                        toast.success("Marketing Channel Removed Succesfully");
                        searchChannels();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Marketing Channel: ' + error.message);
                }
                finally{
                    selectedIds.value = [];
                }
            }else if(selectedIds.value.length > 1){
                toast.error("You have selected more than 1 Marketing Channel") 
            }else{
                toast.error("Please Select A Marketing Channel To Remove")
            }
        }
        const removeChannels = async() =>{
            if(selectedIds.value.length){
                let formData = {
                    company: companyID.value,
                    marketing_channel: selectedIds.value,
                }
                try{
                    const response = await store.dispatch('Marketing_Channels/deleteMarketingChannel',formData)
                    if(response && response.status == 200){
                        toast.success("Marketing Channel(s) Removed Succesfully");
                        searchChannels();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Marketing Channel(s): ' + error.message);
                }
                finally{
                    selectedIds.value = [];
                }
            }else{
                toast.error("Please Select A Marketing Channel To Remove")
            }
        }
        const showLoader = () =>{
            loader.value = "block";
        }
        const hideLoader = () =>{
            loader.value = "none";
        }
        const searchChannels = () =>{
            showLoader();
            showNextBtn.value = false;
            selectedIds.value = [];
            showPreviousBtn.value = false;
            let formData = {
                name: name_search.value,
                type: type_search.value,
                company_id: companyID.value,
                page_size: selectedValue.value
            }
            axios
            .post(`api/v1/marketing-channels-search/?page=${currentPage.value}`,formData)
            .then((response)=>{
                channelsList.value = response.data.results;
                store.commit('Marketing_Channels/LIST_MARKETING_CHANNELS', channelsList.value)
                depResults.value = response.data;
                depArrLen.value = channelsList.value.length;
                depCount.value = depResults.value.count;
                pageCount.value = Math.ceil(depCount.value / selectedValue.value);
                
                if(response.data.next){
                    showNextBtn.value = true;
                }
                if(response.data.previous){
                    showPreviousBtn.value = true;
                }
            })
            .catch((error)=>{
                console.log(error);
            })
            .finally(()=>{
                hideLoader();
            })
        }
        const loadPrev = () =>{
            if (currentPage.value <= 1){
                currentPage.value = 1;
            }else{
                currentPage.value -= 1;
            }
            
            searchChannels();
        }
        const loadNext = () =>{
            if(currentPage.value >= pageCount.value){
                currentPage.value = pageCount.value;
            }else if(currentPage.value < pageCount.value){
                currentPage.value += 1;
            }
            
            searchChannels();
        }
        const firstPage = ()=>{
            currentPage.value = 1;
            searchChannels();
        }
        const lastPage = () =>{
            currentPage.value = pageCount.value;
            searchChannels();
        };
        const selectSearchQuantity = (newValue) =>{
            selectedValue.value = newValue;
            searchChannels(selectedValue.value);
        };
        const dropdownOptions = ref([
            {label: 'Populate Default', action: 'populate-default', icon: 'fa-magic', colorClass: 'text-yellow-600', rightName: 'Adding Marketing Channels'}, 
        ]);
        const handleDynamicOption = async(option) =>{
            if(option == 'populate-default'){
                showLoader();
                let formData = {
                    company: companyID.value,
                }
                await axios.post('api/v1/autopopulate-marketing-channels/',formData).
                then((response)=>{
                    if(response.data.msg == "Success"){
                        toast.success("Success!")
                        searchChannels();
                    }else{
                        toast.error(response.data.msg)
                    }
                })
                .catch((error)=>{
                    toast.error(error.message)
                })
                .finally(()=>{
                    hideLoader();
                })
            }
        };
        const resetFilters = () =>{
            name_search.value = "";
            type_search.value = "";
            currentPage.value = 1;
            searchChannels();
        };
        const closeModal = async() =>{
            depModalVisible.value = false;
            handleReset();
        }
        onMounted(()=>{
            searchChannels();
        })
        return{
            title,idField, searchChannels, addButtonLabel, searchFilters, resetFilters, tableColumns, channelsList,handleSelectionChange,
            currentPage,depResults, depArrLen, depCount, pageCount, showNextBtn, showPreviousBtn,modal_top, modal_left, modal_width,
            loadPrev, loadNext, firstPage, lastPage, actions, formFields, depModalVisible, addNewChannel,
            displayButtons,flex_basis,flex_basis_percentage, handleActionClick, handleReset, saveChannel,
            showLoader, loader, hideLoader, modal_loader, showModalLoader, hideModalLoader, removeChannel, removeChannels,
            addingRight,removingRight,rightsModule, closeModal,selectedValue, selectSearchQuantity,dropdownOptions, handleDynamicOption
        }
    }
}
</script>